import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogMediaPlayerComponent } from './dialog-media-player.component';
import { SharedModules } from '../../shared.modules';
import { CardModule } from '../card/card.module';

@NgModule({
  declarations: [DialogMediaPlayerComponent],
  imports: [
    CommonModule,
    SharedModules,
    CardModule
  ],
  exports: [DialogMediaPlayerComponent]
})
export class DialogMediaPlayerModule { }
